import { FC } from 'react';
import styles from 'partials/card/voucher-card.module.scss';

export const SkeletonVoucherCompanies: FC = () => {
	// Inline skeleton style
	const skeletonStyle: React.CSSProperties = {
		display: 'inline-block',
		background: '#f2f2f4',
		borderRadius: 4,
		minHeight: 16,
		minWidth: 80,
		width: '100px',
		height: '16px',
		animation: 'skeleton-loading 1.2s infinite ease-in-out'
	};

	return (
		<div className="h-100 d-flex flex-column">
			<h5 className="text-gray-3 mb-3 fs-5 fw-400">
				<span style={skeletonStyle} />
			</h5>
			<div className="flex-grow-1">
				{[...Array(5)].map((_, idx) => (
					<div
						key={idx}
						className={styles.businessPartner}
						style={{ opacity: 0.7 }}>
						<div className={styles.businessPartnerLogoWrapper}>
							<div
								style={{
									width: 50,
									height: 50,
									borderRadius: '8px',
									background: '#f2f2f4',
									animation:
										'skeleton-loading 1.2s infinite ease-in-out'
								}}
							/>
						</div>
						<div className="d-flex flex-column flex-grow-1">
							<div
								style={{
									width: '60%',
									height: 18,
									background: '#f2f2f4',
									borderRadius: 4,
									marginBottom: 8,
									animation:
										'skeleton-loading 1.2s infinite ease-in-out'
								}}
							/>
							<div
								style={{
									width: '40%',
									height: 14,
									background: '#f2f2f4',
									borderRadius: 4,
									animation:
										'skeleton-loading 1.2s infinite ease-in-out'
								}}
							/>
						</div>
					</div>
				))}
			</div>
			<style>
				{`
					@keyframes skeleton-loading {
							0% { opacity: 1; }
	                        50% { opacity: 0.4; }
	                        100% { opacity: 1; }
					}`}
			</style>
		</div>
	);
};
